import { getPrePacksPrefix } from "../helpers";
import * as React from "react";
import { scrollToTop } from "../../components/helpers";
class BaseFilter extends React.Component {
    constructor() {
        super(...arguments);
        this.filter = React.createRef();
        this.baseClassName = getPrePacksPrefix("filter");
        this.handleOnClick = () => {
            this.props.onClick({
                id: this.props.id,
                name: this.props.name,
                index: this.props.index,
            });
            this.filter.current && this.props.handleAnimation(this.filter.current);
        };
    }
    render() {
        return (
        // ToDo when react version is migrate to React 17 or 18 to be added also img attrbut loading="lazy" - https://jira.dkcorpit.com/browse/SB-22555
        React.createElement("button", { className: this.baseClassName, type: "button", role: "tab", "aria-selected": this.props.isSelected, onClick: this.handleOnClick, "data-testid": "button-prepacks-filter", ref: this.filter },
            this.props.logo && React.createElement("img", { src: this.props.logo, className: `${this.baseClassName}-team-logo`, "data-testid": "prepacks-filter-team-logo", alt: `${this.props.name} logo`, width: "16px", height: "16px" }),
            this.props.name));
    }
}
export const FilterWeb = (props) => React.createElement(BaseFilter, Object.assign({}, props));
export const Filter = (props) => {
    const filerProps = Object.assign(Object.assign({}, props), { onClick: (options) => {
            props.onClick(options);
            scrollToTop();
        } });
    return React.createElement(BaseFilter, Object.assign({}, filerProps));
};
//# sourceMappingURL=Filter.js.map